import * as e from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/UserList.es.js";
const o = e.forwardRef((r, s) => /* @__PURE__ */ e.createElement(t, { ref: s, ...r, weights: a }));
o.displayName = "UserListIcon";
const c = o;
export {
  c as UserList,
  o as UserListIcon
};
